import { env } from '../env';
export var defaultConsentPolicy = {
  functional: true,
  analytics: true,
  advertising: true,
  essential: true,
  dataToThirdParty: true
};

var ConsentPolicy = /*#__PURE__*/function () {
  function ConsentPolicy() {}

  var _proto = ConsentPolicy.prototype;

  _proto.getCurrentConsentPolicy = function getCurrentConsentPolicy() {
    var consentPolicyManager = this._getConsentPolicyManager();

    if (typeof consentPolicyManager.getCurrentConsentPolicy === 'function') {
      var currentConsentPolicy = consentPolicyManager.getCurrentConsentPolicy();
      return currentConsentPolicy && currentConsentPolicy.policy || defaultConsentPolicy;
    }

    return defaultConsentPolicy;
  };

  _proto._getConsentPolicyManager = function _getConsentPolicyManager() {
    var globalObject = env();

    if (globalObject) {
      if (globalObject.Wix && globalObject.Wix.Utils) {
        return globalObject.Wix.Utils;
      } else if (globalObject.consentPolicyManager) {
        return globalObject.consentPolicyManager;
      }
    }

    return {
      getCurrentConsentPolicy: function getCurrentConsentPolicy() {
        return {
          policy: defaultConsentPolicy
        };
      }
    };
  };

  return ConsentPolicy;
}();

export default new ConsentPolicy();